import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import PropertyFeaturesForm from '../components/PropertyFeaturesForm';
import propertiesService from '../services/propertiesService';
import { useToast } from '../contexts/ToastContext';
import './PropertyFeatures.css';

function PropertyFeatures() {
  const navigate = useNavigate();
  const location = useLocation();
  const property = location.state?.property ?? null;
  const { addToast } = useToast();
  const [isSaving, setIsSaving] = useState(false);

  const persist = async (updatedProperty) => {
    setIsSaving(true);
    try {
      await propertiesService.createProperty(updatedProperty);
      addToast(`"${updatedProperty.name}" has been saved.`, 'success');
      navigate('/dashboard');
    } catch (err) {
      addToast('Could not save property. Please try again.', 'error');
    } finally {
      setIsSaving(false);
    }
  };

  // "Save & Finish" — full property with features
  const handleSave = (updatedProperty) => persist(updatedProperty);

  // "Skip for Now" — save boundary without features so the work isn't lost
  const handleSkip = () => persist({ ...property, features: [] });

  return (
    <div className="features-page">
      <PropertyFeaturesForm
        property={property}
        stepLabel="Step 2 of 2"
        saveLabel={isSaving ? 'Saving…' : 'Save & Finish'}
        skipLabel={isSaving ? 'Saving…' : 'Skip for Now'}
        onSave={handleSave}
        onSkip={handleSkip}
        disabled={isSaving}
      />
    </div>
  );
}

export default PropertyFeatures;


